
import { supabase } from "@/integrations/supabase/client";

// Function to check if tables exist and create them if they don't
export async function ensureTablesExist(): Promise<boolean> {
  try {
    // Attempt to query the tables directly to check if they exist
    const { error: cameraError } = await supabase
      .from('camera_inventory')
      .select('id')
      .limit(1);
    
    // If the camera table doesn't exist, create it
    if (cameraError && cameraError.code === '42P01') { // Table doesn't exist error code
      console.log('Camera table does not exist, creating...');
      
      try {
        // Try to create camera table using direct query
        // We use 'any' type casting here to bypass TypeScript restrictions
        // This is necessary since the RPC functions aren't in the type definitions
        const { error: createError } = await (supabase.rpc as any)('create_camera_table', {});
        
        if (createError) {
          console.error('Error creating camera table via RPC:', createError);
          return false;
        }
      } catch (err) {
        console.error('Failed to create camera table:', err);
        return false;
      }
    }
    
    // Attempt to query lens table
    const { error: lensError } = await supabase
      .from('lens_inventory')
      .select('id')
      .limit(1);
    
    // If the lens table doesn't exist, create it
    if (lensError && lensError.code === '42P01') { // Table doesn't exist error code
      console.log('Lens table does not exist, creating...');
      
      try {
        // Try to create lens table using direct query
        // We use 'any' type casting here to bypass TypeScript restrictions
        const { error: createError } = await (supabase.rpc as any)('create_lens_table', {});
        
        if (createError) {
          console.error('Error creating lens table via RPC:', createError);
          return false;
        }
      } catch (err) {
        console.error('Failed to create lens table:', err);
        return false;
      }
    }
    
    // Verify that tables were created successfully
    const { error: verifyCamera } = await supabase
      .from('camera_inventory')
      .select('id')
      .limit(1);
      
    const { error: verifyLens } = await supabase
      .from('lens_inventory')
      .select('id')
      .limit(1);
    
    if (verifyCamera || verifyLens) {
      console.error('Tables were not created successfully:', verifyCamera || verifyLens);
      return false;
    }
    
    console.log('Tables exist or were created successfully');
    return true;
  } catch (error) {
    console.error('Error checking or creating tables:', error);
    return false;
  }
}
